// Ruecksprung in der Kopfleiste interner Seiten, eigene Datei, damit die
// Seiten-Vorlage nicht die Registry importiert
export const INTERNAL_HOME = {
  to: '/internal/updates',
  label: 'Interne Updates'
}
